import React, { useState } from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/styles';
import { Paper, Button, Input } from '@material-ui/core';
import SearchIcon from '@material-ui/icons/Search';
import { useTranslation } from "react-i18next";

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    alignItems: 'center'
  },
  search: {
    flexGrow: 1,
    height: 42,
    padding: theme.spacing(0, 2),
    display: 'flex',
    alignItems: 'center'
  },
  searchIcon: {
    marginRight: theme.spacing(2),
    color: theme.palette.icon
  },
  searchInput: {
    flexGrow: 1
  },
  searchButton: {
    marginLeft: theme.spacing(2)
  }
}));

const Search = props => {
  const { onSearch, className, ...rest } = props;
  const [search, setSearch] = useState('');

  const classes = useStyles();

  const handleInput = (e) => {
    e.persist && e.persist();
    const { value } = e.target;
    setSearch(value);
  }

  const [t] = useTranslation();

  const handleClick = () => {
    onSearch(search);
  }

  return (
    <div
      {...rest}
      className={clsx(classes.root, className)}
    >
      <Paper
        className={classes.search}
        elevation={1}
      >
        <SearchIcon className={classes.searchIcon} />
        <Input
          className={classes.searchInput}
          disableUnderline
          placeholder={t("page.sportsmen.placeHolder")}
          onChange={handleInput}
          inputProps={{ 'data-testid': 'search-input' }}
        />
      </Paper>
      <Button
        className={classes.searchButton}
        onClick={e => handleClick(e)}
        size="large"
        variant="contained"
        data-testid="search-submit"
      >
        {t("buttons.search")}
      </Button>
    </div>
  );
};

Search.propTypes = {
  className: PropTypes.string,
  onSearch: PropTypes.func
};

export default Search;
